var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBgBlur = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 695,
    height: 702,
    viewBox: "0 0 695 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_48_5137)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135.082,
    cy: 350.916,
    rx: 327.2,
    ry: 86.0374,
    transform: "rotate(12.8106 135.082 350.916)",
    fill: "#3D4255"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_48_5137",
    x: -424.554,
    y: -0.000244141,
    width: 1119.27,
    height: 701.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_48_5137"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBgBlur);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg_blur.36a3d37109f1b4de512cefe13f050aa1.svg";